import React, { PureComponent } from 'react';
import glamorous from 'glamorous';
import { filter, orderBy, map, get } from 'lodash';
import { injectIntl } from 'react-intl';
import * as d3 from 'd3';

import { createTooltip } from '../helpers';

class BarChart extends PureComponent {
  constructor(props) {
    super(props);
    this.chartRef = null;
  }

  componentDidMount() {
    buildChart(this.props, this.chartRef);
  }

  render() {
    return (
      <glamorous.Div
        innerRef={r => this.chartRef = r}
        className="d3-chart"
        css={{
          height: this.props.isFullScreen ? '100%' : 400,
          width: '100% !important',
        }}
      />
    );
  }
}

export default injectIntl(BarChart);


function buildChart(props, element) {
  const {
    dataset,
    options,
    intl,
    isFullScreen,
    goToSearchPage,
  } = props;

  const barChartData = orderBy(filter(dataset.data, x => x.recallCount > 0), ['recallCount'], ['desc']);
  const yLabelsWidth = 40;

  element.innerHTML = '';

  const xLabelsHeight = element.offsetHeight * 0.25;
  const margin = { top: 10, bottom: 0, left: 0, right: 0 };

  const width = element.offsetWidth - margin.left - margin.right;
  const height = element.offsetHeight - margin.top - margin.bottom;

  const chartWidth = width;
  const chartHeight = height - xLabelsHeight;

  const svg = d3
    .select(element)
    .append('svg')
    .attr('width', chartWidth)
    .attr('height', height)
    .attr(
      'transform',
      `translate(${margin.left + (width - chartWidth) / 2}, ${margin.top})`
    );

  // chart plot area
  const chart = svg
    .append('g')
    .attr('class', 'bars')
    .attr('transform', `translate(${yLabelsWidth}, ${margin.top})`);

  // define X & Y domains
  const xDomain = map(barChartData, x => x.label);
  const yDomain = [0, d3.max(barChartData, x => x.recallCount)];

  // create scales
  const xScale = d3
    .scaleBand()
    .padding(0.1)
    .domain(xDomain)
    .rangeRound([0, chartWidth - yLabelsWidth]);

  const yScale = d3
    .scaleLinear()
    .domain(yDomain)
    .range([chartHeight, 0])

  // tooltips
  const tip = createTooltip({ intl, isMovingX: false });
  chart.call(tip);

  // X Axis
  svg
    .append('g')
    .attr('class', 'axis axis-x')
    .attr(
      'transform',
      `translate(${yLabelsWidth}, ${margin.top + chartHeight})`
    )
    .call(d3.axisBottom(xScale))
    .selectAll('text')
    .attr('x', -5)
    .attr('dy', '.3em')
    .attr('transform', 'rotate(-45)')
    .text((label, i) => {
      // First label has less space than others and is more truncated
      if (!isFullScreen && label && label.length > (i === 0 ? 12 : 16)) {
        return label.substring(0, i === 0 ? 9 : 13) + '...'
      } else if (
        isFullScreen &&
        label &&
        label.length > (i === 0 ? 16 : 32)
      ) {
        return label.substring(0, i === 0 ? 13 : 29) + '...'
      } else {
        return label
      }
    })
    .style('text-anchor', 'end')
    .style('font-size', '12px');

// Y Axis
  svg
    .append('g')
    .attr('class', 'axis axis-y')
    .attr('transform', `translate(${yLabelsWidth}, ${margin.top})`)
    .call(d3.axisLeft(yScale))
    .selectAll('.tick text')
    .style(
      'display',
      options && options.hideYAxis ? 'none' : 'block'
    );

  // Bars
  chart
    .selectAll('.bar')
    .data(barChartData)
    .enter()
    .append('rect')
    .attr('class', 'bar')
    .attr('class', 'pointer')
    .attr('x', d => xScale(d.label))
    .attr('y', d => yScale(0))
    .attr('width', xScale.bandwidth())
    .attr('height', 0)
    .style('fill', '#8CC841')
    .on('mouseover', tip.show)
    .on('mousemove', tip.move)
    .on('mouseout', tip.hide)
    .on('click', d => {
      tip.hide();
      goToSearchPage(get(d, 'link.params'), intl);
    })
    .transition()
    .delay((d, i) => i * 10)
    .attr('y', d => yScale(d.recallCount))
    .attr('height', d => chartHeight - yScale(d.recallCount));
}



// WEBPACK FOOTER //
// ./src/views/dashboard/chart/bar-chart/index.js